import HelpAction from "./HelpAction";
import Legenda from "./Legenda";
import { useState } from "react";
import PainelOd from "./PainelOd";
import { limpa, limpaLegenda, completaLest, completEst, valid, download, onCritChange2, onSpecChange2, onSpecBlur2, cparte2, sh2 } from "./Aux.js";

const Ode = (props) => {

    props.setComp('ode');
    document.title = "bqmaps";
    document.querySelector('meta[name="description"]').setAttribute('content','Metro do Porto. Consultar origens ou destinos de etapas. Query trip origins or destinations.');
    
    const [csv, setCsv] = useState('');
    var specs = {...props.specs};
    
    function odeQuery(e){
        e.preventDefault();
        limpaLegenda();
        let s = {...props.specs};
        let orde = "origem";
        if(props.specs.od === 'Destino'){
            orde = "destino";
        }
        var d = 'odeu';
        var txtd = "Úteis";
        if (props.specs.dias === 'Todos'){
            d = 'odet';
            txtd = "Todos";
        }
        let est = props.specs.est;
        if (est !== '') {
            est = est.split(" ");
            est = limpa(est, 0, 82, props.ling, 0);
        }
        if (s.est.length < 1 && !props.specs.la && !props.specs.az && !props.specs.verm && !props.specs.vi && !props.specs.verd && !props.specs.tc && !props.specs.ptc && !props.specs.am ) {
            est = ["0"];
        };
        s.est = est.toString().replace(/,/g, ' ');
        props.setSpecs(s);
        let lest = [];
        let j = 0;
        let x = 0;
        for (let i = 0; i < est.length; i++) {
            x = props.varGlob.e[parseInt(est[i])];
            j++;
            if (j === 12){
                x = "<br>" + x;
                j=0;
            }
            if (x !== "") lest.push(x);
        }
        let anos = props.specs.anos;
        if (anos === '') {
            anos = '2019 2020 2021';
        }
        anos = anos.split(" ");
        anos = limpa(anos, 2019, 2021, props.ling, 2021);
        if( anos.length < 1) {
            anos = ['2019', '2020', '2021'];
            alert('Input errado para anos foi substituído. / Wrong input for years was replaced.')
        };
        s.anos = anos.toString().replace(/,/g, ' ');
        props.setSpecs(s);
        let meses = props.specs.meses;
        if (meses === '') {
            meses = '1 2 3 4 5 6 7 8 9 10 11 12';
        }
        meses = meses.split(" ");
        meses = limpa(meses, 1, 12, props.ling, 2);
        if( meses.length < 1) {
            meses = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
            alert('Input errado para meses foi substituído. / Wrong input for months was replaced.')
        };
        let lmeses = [];
        for (let i = 0; i < meses.length; i++) {
            lmeses.push(props.varGlob.m[parseInt(meses[i])-1]);
        }
        s.meses = meses.toString().replace(/,/g, ' ');
        props.setSpecs(s);
        let horas = props.specs.horas;
        if (horas === '') {
            horas = '1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24';
        }
        horas = horas.split(" ");
        horas = limpa(horas, 1, 24, props.ling, 8);
        if( horas.length < 1) {
            horas = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24'];
            alert('Input errado para horas foi substituído. / Wrong input for hours was replaced.')
        };
        s.horas = horas.toString().replace(/,/g, ' ');
        props.setSpecs(s);
        specs = s;
        let mensagem = "Coloridas estações em função do número de etapas<br>";
        let trocos = {'la': props.specs.la, 'az': props.specs.az, 'verm': props.specs.verm, 'verd': props.specs.verd, 'ptc': props.specs.ptc, 'vi': props.specs.vi, 'tc': props.specs.tc, 'am': props.specs.am}
        lest = completaLest(lest, trocos);
        mensagem += "Com " + orde + " em: " + lest; 
        mensagem += "<br>Nos dias:      "  + txtd; 
        mensagem += "<br>Do(s) ano(s):      "  + anos; 
        mensagem += "<br>No(s) mes(es) de:     " + lmeses;
        mensagem += "<br>Na(s) hora(s):     " + horas;
        let filtro = anos + ";" + lmeses + ";" + horas + ";" + txtd + ";Com " + orde + ";" + lest
        const params = {
            "serv": "ode",
            "est": completEst(est, trocos),
            "anos": anos,
            "meses": meses,
            "horas": horas,
            "d": d,
            "orde": orde
        };
        odeFetchAsync (
            "/bqmapsnode/?params="  + JSON.stringify(params), filtro
        );
    }
    
    async function odeFetchAsync (url, filtro) {
        let response = await fetch (url, {
            mode: 'no-cors',
            credentials: 'same-origin',
        });
        if (response.ok) {
            let resultados = await response.json();
            if (resultados.length < 1) {
                odeAlertaDados();
                return resultados;
            } else { 
                console.log(resultados);
                let s = {...specs};
                s.res = resultados;
                props.setSpecs(s);
                odeSaveCsv(resultados, filtro);
                return resultados;
            }
        } else {
            console.log(url, response.headers);
            console.log('HTTP ERROR: ' + response.status);
        }
    }

    function odeAlertaDados() {
        if (props.ling === 'pt') {
            alert ('Não há dados para o período especificado! Só de Jan 2019 a Fev 2021, inc. (excepto Abr 2020)');
        } else {
            alert ('No data for the specified period! Only for Jan 2019 to Feb 2021, inc. (Apr 2020 excluded)')
        }
    }

    async function odeSaveCsv(resultados, filtro){
        setCsv('');
        let ponto = resultados[0];
        let campo = Object.keys(ponto);
        let csvCont = "Anos;Meses;Horas;Dias;O/D Etapas;Estações \n";
        csvCont = csvCont + filtro + "\n \n";
        csvCont = csvCont + "N.º;Código;Etapas \n";
        for (let i=0; i<83; i++){
            csvCont = csvCont + resultados[i][campo[0]] + ";";
            csvCont = csvCont + props.varGlob.e[resultados[i][campo[0]]] + ";";
            csvCont = csvCont + parseInt(resultados[i][campo[3]]) + "\n";
        }
        let response = await fetch ("/bqmapsnode/?fileToWrite=" + encodeURIComponent(csvCont), {
            mode: 'no-cors',
            credentials: 'same-origin',
        })
        let fileName = await response.json();
        if (!response.ok) {
            console.log(response.headers);
            console.log('HTTP ERROR: ' + response.status);
        }
        setCsv(fileName);
    }
    
    
    return ( 
        <div className="ode">
            <div id="toast"></div>
            <div id="stats">
                <div id="menu">
                    <HelpAction 
                        ling={props.ling} 
                        titPt={"Colorir estações em função do número de etapas"}
                        titUk={"To color stations according to the number of trips"}
                        helpPt={"https://docs.google.com/presentation/d/1bCbJ-ZYCCzn5qSMWc5r3NGBR6OrQhV3NhXVz1kL7pXs/edit?usp=share_link"}
                        helpUk={"https://docs.google.com/presentation/d/1U45_tRHIsJbDhsu8pzeCQqH4ACjtRpnrGGVUxC_jviA/edit?usp=share_link"}
                        varGlob={props.varGlob}
                        onSpecChange2={onSpecChange2}
                        specs={specs}
                        setSpecs={props.setSpecs}
                        query={odeQuery}
                        csv={csv}
                        download={download} />
                    <PainelOd
                        ling={props.ling}
                        specs={props.specs}
                        setSpecs={props.setSpecs}
                        setComp={props.setComp}
                        valid={valid}
                        onCritChange2={onCritChange2}
                        sh2={sh2}
                        onSpecChange2={onSpecChange2}
                        onSpecBlur2={onSpecBlur2}
                        cparte2={cparte2}
                        varGlob={props.varGlob}
                        BotA1={'OD Vi'}
                        TitA1={"Colorir estações em função do número de viagens"}
                        RefA1={"odv"}  />
                    <Legenda />
                </div>   
            </div>
        </div>
        
    );
}

export default Ode;